import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/bancos/depositoRecibo';
import Depositos from './DepositoReciboList';


const ms2p = (state) => {
  return {
    ...state.deposito_recibo_prd,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Depositos);
